// extracted by mini-css-extract-plugin
export var closeButton = "tvcs5";
export var container = "ZgIZI";
export var crossLeft = "z1ArL";
export var crossRight = "ynp5E";
export var fadeInOpacity = "DH6nr";
export var message = "Xl2by";
export var root = "fm9LV";